import { Briefcase, User } from 'lucide-react';

/**
 * AccountTypeTabs — segmented control «For candidates / For employers».
 * Sits above the inner Login/Sign Up tabs in AuthPanel.
 *
 * - value: 'candidate' | 'employer'
 * - onChange: (next) => void  (caller persists in localStorage)
 */
export default function AccountTypeTabs({ value, onChange, disabled = false }) {
  const tabs = [
    { id: 'candidate', label: 'For candidates', sub: 'Find your next role', icon: User },
    { id: 'employer', label: 'For employers', sub: 'Screen candidates faster', icon: Briefcase },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 rounded-2xl bg-[#F0F2F8] p-1.5">
      {tabs.map((tab) => {
        const TabIcon = tab.icon;
        const active = value === tab.id;
        return (
          <button
            key={tab.id}
            type="button"
            disabled={disabled}
            onClick={() => onChange(tab.id)}
            className={`flex flex-col items-center gap-1.5 py-3 px-3 rounded-xl transition-all ${
              active
                ? 'bg-white shadow-sm ring-1 ring-black/[0.04]'
                : 'hover:bg-white/40'
            } disabled:opacity-50`}
            aria-pressed={active}
          >
            <div
              className={`flex items-center gap-2 ${
                active ? 'text-[#1E293B]' : 'text-gray-500'
              }`}
            >
              <TabIcon className="w-4 h-4" />
              <span className="text-[13px] font-bold">{tab.label}</span>
            </div>
            <span
              className={`text-[11px] ${
                active ? 'text-gray-500' : 'text-gray-400'
              }`}
            >
              {tab.sub}
            </span>
          </button>
        );
      })}
    </div>
  );
}
